<template>
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M1.24459 15.9874C1.10888 15.9874 0.970007 15.9338 0.865867 15.8296C0.657585 15.6213 0.657585 15.2805 0.865867 15.0722L7.99485 7.94006L0.970007 0.91522C0.761726 0.706923 0.761726 0.366079 0.970007 0.157798C1.17829 -0.0504834 1.51912 -0.0504834 1.7274 0.157798L9.13095 7.56134C9.33923 7.76963 9.33923 8.11045 9.13095 8.31874L1.62326 15.8296C1.51912 15.9337 1.38027 15.9874 1.24457 15.9874L1.24459 15.9874Z"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
